module.exports = __webpack_public_path__ + "static/media/fishingRod.75e8cbf8.svg";